import { Component } from "react";


class Loader extends Component
{
   
    render()
    {
    return(
        
    <div className="load-container">
	<div className="container-fluid">
<div align="center" className="fond">
  <div className="contener_general">
      <div className="contener_mixte"><div className="ballcolor ball_1">&nbsp;</div></div>
      <div className="contener_mixte"><div className="ballcolor ball_2">&nbsp;</div></div>
      <div className="contener_mixte"><div className="ballcolor ball_3">&nbsp;</div></div>
      <div className="contener_mixte"><div className="ballcolor ball_4">&nbsp;</div></div>
  </div>
</div>

	</div>
</div>
)
    }

}

export default Loader